/* 🤖 this file was generated by svg-to-ts*/
export const icoTickCircleDuo: {
  name: 'tick-circle-duo';
  data: string;
} = {
  name: 'tick-circle-duo',
  data: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path opacity=".12" d="M11.9 21.8c5.468 0 9.9-4.432 9.9-9.9S17.368 2 11.9 2 2 6.432 2 11.9s4.432 9.9 9.9 9.9z" /><path d="M12 22C6.49 22 2 17.51 2 12S6.49 2 12 2s10 4.49 10 10-4.49 10-10 10zm0-18c-4.42 0-8 3.58-8 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8z" /><path d="M10.507 16a.987.987 0 01-.707-.308L7.29 13.016a1.108 1.108 0 010-1.498.948.948 0 011.404 0l1.802 1.922 4.808-5.13a.948.948 0 011.404 0 1.108 1.108 0 010 1.498l-5.515 5.884a.947.947 0 01-.707.308h.02z" /></svg>`
};
